import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactNode } from "react";
import { InputGroupPlacement } from "./InputGroupPlacement";
import InputGroupBaseProps from "./InputGroupBaseProps";
import styles from './inputGroup.module.scss';

interface Props extends InputGroupBaseProps {
  children: ReactNode;
  addonType?: "select";
};

const InputGroup = ({
  children,
  placement = "append",
  contentText,
  contentIcon,
  contentElement,
  addonType
}: Props) => {
  // helpers
  const getAddonClasses = () => { 
    let result = "input-group-text";
    if (addonType === "select") {
      result += ` ${styles.inputGroupSelect}`;
      result += placement === "prepend" ? ` ${styles.selectPrepend}` : ` ${styles.selectAppend}`;
    }

    return result;
  }

  // sub-renders
  const rendedAddon = (addonPlacement: InputGroupPlacement) => {
    const content = renderAddonContent();
    const addonClass = addonType === "select" ? ` ${styles.inputGroupSelect}` : "";

    if (addonPlacement === placement && content !== undefined) {
      return (
        <div className={`input-group-${addonPlacement}`}>
          <span className={getAddonClasses()}>{content}</span>
        </div>
      );
    }
  };

  const renderAddonContent = () => {
    if (contentIcon) {
      return <FontAwesomeIcon icon={contentIcon} />;
    } else if (contentText) {
      return <span
        dangerouslySetInnerHTML={{ __html: contentText }}
      />
    } else if (contentElement) {
      return contentElement;
    }
  };

  // render
  return (
    <div className="input-group">
      {rendedAddon("prepend")}
      {children}
      {rendedAddon("append")}
    </div>
  );
};

export default InputGroup;
